/* src/app/components/payroll/timesheets/mass-adjustments/mass-batch-result-list/mass-batch-result-list.component.css */
.table-style {
  width: 100%;
}
.details-header {
  display: flex;
  align-items: center;
  gap: 16px;
}
/*# sourceMappingURL=mass-batch-result-list.component-QZ2CFVPF.css.map */
